<template>
  <div>
    <div @click="hidePost">
      <Video
        :room="room"
        :video="video"
        @offAudioStream="offAudioStream"
        :minimal="post ? post.visible : false"
      />
    </div>
    <div v-if="post && post.visible">
      <Post
        @hidePost="hidePost"
        :post="post.item"
        :room="room"
        :customer="customer"
        @setCustomer="setCustomer"
        @showPost="showPost"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Video: () => import(/* webpackPrefetch: true */ '@/views/room/components/mux/Video.vue'),
    Post: () => import(/* webpackPrefetch: true */ '@/views/room/components/post/show/Index.vue')
  },
  props: {
    room: {
      type: Object,
      default: null
    },
    video: {
      type: Object,
      default: null
    },
    post: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      show: false
    }
  }
})
export default class Player extends Vue {
  hidePost () {
    this.post.visible = false
  }

  offAudioStream () {
    this.$emit('offAudioStream')
  }

  setCustomer () {
    this.$emit('setCustomer')
  }
  showPost (selectedPost) {
    this.$emit('showPost', selectedPost)
  }
}
</script>
